module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1500.13c52a0e.svg";